import classes from "./ReviewCard.module.scss";
import React, { useEffect, useState } from "react";
import PinDropIcon from "@mui/icons-material/PinDrop";
import DateRangeIcon from "@mui/icons-material/DateRange";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { Link } from "react-router-dom";
import { Skeleton } from "antd";
import countryFlags from "../../assets/data/countryFlags";
import EmailIcon from "@mui/icons-material/Email";
import avatarImg from "../../assets/imgs/avatar2.png";
import Rating from "@mui/material/Rating";
import OptimizedImage from "../../components/OptimizedImage";

const ReviewCard = (props) => {
  function parseDate(date) {
    if (!date) return "";
    return new Date(date).toLocaleString().split(",")[0].replaceAll("/", "-");
  }

  return (
    <div className={classes.card}>
      {props.load ? (
        <div className={classes.imgSkeleton}>
          <Skeleton.Avatar shape={"square"} size={100} active />
        </div>
      ) : (
        <div className={classes.cardImage}>
          {/* {props.img === "" || props.img === null ? (
            <img src={avatarImg} alt="event_img" />
          ) : (
            <img src={props.img} alt="event_img" />
          )} */}
          <OptimizedImage
            alt={props.title}
            sources={[
              {
                type: "image/webp",
                srcSet:
                  props.img === "" || props.img === null
                    ? avatarImg
                    : props.img,
              },
            ]}
            fallback={{
              src: "../../assets/imgs/notFound/fallback-image.png",
            }}
          />
        </div>
      )}
      {props.load ? (
        <div className={classes.txtSkeleton}>
          <Skeleton active />
        </div>
      ) : (
        <ul className={classes.cardContent}>
          <div className={classes.userInfo}>
            <h3 data-testid="title">{props.title}</h3>
          </div>
          <div className={classes.sectionDetails}>
            <div className={classes.tripInfo}>
              <div className={classes.programName}>{props.programName}</div>
              <div className={classes.location}>
                <PinDropIcon /> {props.location}
              </div>
            </div>
          </div>
          <div className={classes.time}>
            <DateRangeIcon />
            {parseDate(props.startDate)}
            {"  to  "}
            {parseDate(props.endDate)}
          </div>
          <div className={classes.content}>{props.content}</div>
          <Link to={`/programs/${props?.progId}`}>
            <button className={classes.btn}>
              {props.isReview ? "Review Program" : "Read More"}
              <TrendingFlatIcon />
            </button>
          </Link>
        </ul>
      )}
    </div>
  );
};

export default ReviewCard;
